<template>
    <div class="d-inline-block text-black text-center"
         :style="grayscaleStyle"
         :title="integration.name"
    >
        <img v-if="integration.icon_url"
             :src="integration.icon_url"
             :alt="integration.code"
             style="height: 1.25rem;">
        <i v-else :class="integration?.icon || 'fas fa-question-circle'"/>
    </div>
</template>

<script>
export default {
    props: {
        integration: Object,
        grayscale: Boolean
    },

    computed: {
        grayscaleStyle() {
            if (this.grayscale) {
                return 'filter: grayscale(1);';
            }

            return null;
        }
    },
}
</script>
